import { METER_PER_KILOMETER } from '@/shared/consts/distance.const';

const format = {
	formatToMetric: (meters: number): string => {
		if (meters < METER_PER_KILOMETER) {
			return `${Math.ceil(meters)}m`;
		}
		return `${(meters / METER_PER_KILOMETER).toFixed(2)}km`;
	},
};

export default format;
